import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useActiveForm } from '@/components/form/ActiveSwitch';
import { useAppAlert } from '@Components/AppAlert';
import FormWrapper from '@Components/form/Wrapper';
import history from 'utils/history';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { UserProvider, useUserStore } from '../store';

const propTypes = {
  match: PropTypes.object,
}

const UserForm = () => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit } } = useUserStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { active, setActive } = useActiveForm(item)

  useLoad(id)

  const handleSubmit = useSubmit()

  const handleSubmitAndGoBack = useCallback(async payload => {
    try {
      await handleSubmit({ ...payload, active })
      history.push('/admin/users');
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `User ${message}.`)
    } catch {
      handleError('Error', 'User was not saved.')
    }
  }, [handleSubmit, handleSuccess, handleError, active])

  if (!item) {
    return null
  }

  return <>
    <FormWrapper title='User'>
      <Heading data={item} active={active} onChangeActive={setActive} />
      <Form data={item} handleSubmit={handleSubmitAndGoBack} />
    </FormWrapper>
  </>
}

UserForm.propTypes = propTypes

export default function UserFormLayout() {
  return <UserProvider>
    <UserForm />
  </UserProvider>
}
